import { GET_DASHBOARD_INFO_FAIL, GET_DASHBOARD_INFO_SUCCESS, RESET_DASHBOARD_STATE } from "./actionTypes"
  
  const INIT_STATE = {
    dashboardInfo: []
  }
  
  const Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
      case GET_DASHBOARD_INFO_SUCCESS:
        return {
          ...state,
          dashboardInfo: action.payload
        }
  
      case GET_DASHBOARD_INFO_FAIL:
        return {
          ...state,
          error: action.payload,
        }
      case RESET_DASHBOARD_STATE:
        return {
          ...state,
          dashboardInfo: [],
        }
      default:
        return state
    }
  }
  
  export default Dashboard
  